import { Redirect } from 'expo-router';

import { routes } from 'utils/routing';

export default function CartPaymentRedirectRoute() {
  return <Redirect href={routes.cartCheckout} />;
}
